import React from 'react';
import './App.css';
import ThreeScene from './ThreeScene';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ThreeScene />
      </header>
    </div>
  );
}

export default App;